




















































































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";
import CFMMultiselect from '@/components/partials/CFMMultiselect.vue'
import {CFMDTODeviceModel } from '@/scripts/services/ClientApiAuto'

@Component<ModelDialog>({
    components: {
        'cfm-multiselect': CFMMultiselect,
    },
    validations() {
        return {
        mmodel:{
            Name: {required},
            IsForTool:false,
            IsForCapacityEquipment:false,
            IsForSparePart:false,
            IsForDevice:false,
        },
        selectedBrand: {
            BrandId: {required}
        },
        }
    },
})
export default class ModelDialog extends CFMDialog {
    mmodel: CFMDTODeviceModel = {Name: ''};
    brandList : {Name:String, Id:Number}[] = [];

    selectedBrand :CFMDTODeviceModel = {Name: ''}

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.model.modelGetById({id: <number>this.id});
        this.mmodel = res.data;
      }
      blockui.unBlockModal();
      const promises = [
      this.getBrands()
      ];
      if(this.isUpdate){
        if(this.mmodel && this.mmodel.Brand){
          this.selectedBrand = this.mmodel;
        }
      }
      await Promise.all(promises);
      blockui.unBlockModal();
    }

    async getBrands(){
      const response = await this.apiClient.brand.brandGetBrands();
      this.brandList = response.data.map(x=>({Name:<string>x.Text, Id:<number>x.Value}));
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.mmodel.Id,
        Name: this.mmodel.Name,
        IsForTool : this.mmodel.IsForTool,
        IsForCapacityEquipment : this.mmodel.IsForCapacityEquipment,
        IsForSparePart : this.mmodel.IsForSparePart,
        IsForDevice : this.mmodel.IsForDevice,
        brandId: this.selectedBrand.BrandId
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.model.modelSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
